import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Fragment, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDrawerStore } from '../../../hooks/useDrawerStore'
import { ListItemButtonStyle, ListItemIconStyle, ListMainItemButtonStyle } from '../../../styles/components/NavSection.styles'
import { LocalStorageKey, RoutesMap } from '../../../types'
import { readLocalStorage, saveLocalStorage } from '../../../toolbox/helpers/local-storage-helpers'
import { navSections } from '../../../toolbox/constants/NavSection'
import ScrollBar from '../Scrollbar/Scrollbar';
import { Role } from '../../../types/roles/roleTypes'
import { useAuthStore } from '../../../hooks/useAuthStore'
import { Planes } from '../../../types/plan/plan'
import { useTicketStore } from '../../../hooks/useTicketStore'
import { Ticket } from '../../../types/slices/ticketType'
import { useSearcherStore } from '../../../hooks/useSearcherStore'
import { shouldUseFullAdminNav } from '../../../toolbox/helpers/fullAdminNav'

export const NavSection = () => {
    //Hooks
    const { user } = useAuthStore()

    const { setSelectedTicket } = useTicketStore()
    const { setSelectedCustomer } = useSearcherStore()
    const { openDrawer } = useDrawerStore()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const initialRuta = readLocalStorage(LocalStorageKey.RUTA)
    const [ruta, setRuta] = useState(initialRuta || '')

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const userRole: Role | any = userData?.userType;

    const validateUserType = (role: any) => {
        if (shouldUseFullAdminNav(user, userData)) {
            return navSections.Admin
        }
        switch (role) {
            case Role.SUPER_ADMIN:
                return navSections.Superadmin
            case Role.ADMIN:
                if (user?.rut == "76868240-2") {
                    return navSections.AdminHildago
                }
                else if (user?.membership === Planes.BASIC) {
                    return navSections.AdminBasic
                } else {
                    // return navSections.Admin
                    return navSections.AdminHildago
                }
            case Role.CLIENT:
                return navSections.Client
            case Role.COMMERCIAL:
                return navSections.rutasAdmin2Hildago
            case Role.SALESMAN:
                return navSections.Salesman
            case Role.SUPERVISOR:
                return navSections.Admin
            case Role.MAINTENANCE:
                return navSections.Admin
            case Role.MECHANIC:
                return navSections.Admin
            case Role.DRIVER:
                return navSections.Admin
        }
    }
    const routes: any = validateUserType(userRole);


    const isModule = (value: any): value is any => {
        return (value as any).name !== undefined
    }
    const handleOnClick = (value: any) => {
        if (isModule(value)) {
            if (ruta === value.name) {
                setRuta('')
            } else {
                saveLocalStorage(LocalStorageKey.RUTA, value.name)
                setRuta(value.name)
            }
        } else {
            openDrawer(false)
            // navigate({ pathname: value.location })
        }
    }

    const handleItemSelected = (pathname: any) => {
        openDrawer(false)
        if (pathname === RoutesMap.SEARCHER_COMPANY) {
            setSelectedCustomer(undefined)
            setSelectedTicket({} as Ticket)
        }
        navigate({ pathname: pathname })
    }

    return (
        <ScrollBar sx={{ height: 1, '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' } }}>
            <List disablePadding sx={{ p: 1 }}>
                {
                    !!(routes?.length > 0) && routes?.map((route: any, index: any) => {
                        // if (route?.type_module == 1) { return }
                        const isItemSelected = ruta === route.name
                        const IconModule = route.icon
                        return (
                            <Fragment key={index}>
                                <ListItemButton
                                    sx={{
                                        fontSize: 14,
                                        ...(isItemSelected ? {
                                            color: 'rgb(18, 28, 76, 0.9)',
                                            textTransform: 'capitalize',
                                            bgColor: 'rgb(230, 247, 255)',
                                            fontWeight: 'fontWeightBold',
                                            padding: '0px 10px 0px 0px'
                                        } : {
                                            padding: '0px 10px 0px 0px'
                                        }),
                                        ...ListMainItemButtonStyle,
                                    }}
                                    onClick={() => handleOnClick(route)}
                                >
                                    <ListItemIcon sx={ListItemIconStyle}>
                                        {IconModule != null ? IconModule : null}
                                    </ListItemIcon>
                                    <ListItemText disableTypography primary={route.name} />
                                    {
                                        isItemSelected ? (
                                            <KeyboardArrowUpIcon />
                                        ) : (
                                            <KeyboardArrowDownIcon />
                                        )
                                    }
                                </ListItemButton>
                                {(
                                    <Collapse in={isItemSelected} timeout="auto" unmountOnExit>
                                        {route.rutas.map((view: any, index: any) => {
                                            // if (view?.type == 1) {return}
                                            const isSubRouteSelected = pathname === view.location
                                            const Icon = view.icon
                                            return (
                                                <Link
                                                    to={view.location}
                                                    onClick={() => handleItemSelected(view.location)}
                                                    key={index}
                                                    style={{ textDecoration: 'none', color: '#000' }}>
                                                    <ListItemButton
                                                        onClick={(e) => handleItemSelected(view.location)}
                                                        key={index}
                                                        sx={{
                                                            ...ListItemButtonStyle,
                                                            fontSize: 13,
                                                            ...(isSubRouteSelected ? {
                                                                color: 'rgb(18, 28, 76, 0.9)',
                                                                bgcolor: 'rgb(230, 247, 255)',
                                                                padding: '0px'
                                                            } : {
                                                                fontWeight: 500,
                                                                padding: '0px'
                                                            }),
                                                        }}
                                                    >
                                                        <ListItemIcon sx={ListItemIconStyle}>
                                                            {Icon != null ? Icon : null}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={view.name_ruta}
                                                        />
                                                    </ListItemButton>
                                                </Link>

                                            )
                                        })}
                                    </Collapse>
                                )}
                            </Fragment>
                        )
                    })
                }
            </List>
        </ScrollBar>
    )
}
